import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import gql from 'graphql-tag';

export const GET_BANNER_QUERY = gql`
query getBannersBuyer($date: timestamptz) {
  banner(where: {start_date: {_lte: $date}, end_date: {_gte: $date}}) {
    id
    image
    title
    organization {
      id
      website
    }
  }
}
`;
export const GET_BANNER_DEFAULT_QUERY = gql`
query getBannersBuyer {
  banner {
    id
    image
    title
    organization {
      id
      website
    }
  }
}
`;
export const GET_CATALOG_BY_ORGANIZATION_ID = gql`
query getCatalogByOrganizationId($organization_id: uuid!) {
  catalog(where: {organization_id: {_eq: $organization_id},catalog_type_id: {_eq: 1}}) {
    id
    name
  }
}
`;
export const INSERT_BANNER_ACTIVITY_MUTATION = gql`
mutation insertBannerActivity($action: String!, $banner_id: Int!) {
  insert_banner_activity(objects: {action_type: $action, banner_id: $banner_id}) {
    affected_rows
  }
}

`;

const banner = {
  namespaced: true,
  state: {
    banners: [],
  },
  actions: {
    async getBanners({ commit }, date) {
      commit('SET_BANNERS', {});
      try {
        let searchQuery = null;
        if (date) {
          searchQuery = {
            query: GET_BANNER_QUERY,
            variables: {
              date,
            },
          };
        } else {
          searchQuery = {
            query: GET_BANNER_DEFAULT_QUERY,
          };
        }

        const response = await apolloClient.query(searchQuery);
        if (response && response.data) {
          commit('SET_BANNERS', response.data.banner);
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    // eslint-disable-next-line no-unused-vars
    async getcatalogByOrganization({ commit }, organizationId) {
      try {
        const searchQuery = {
          query: GET_CATALOG_BY_ORGANIZATION_ID,
          variables: {
            organization_id: organizationId,
          },
        };
        const response = await apolloClient.query(searchQuery);
        if (response && response.data && response.data.catalog) {
          return response.data.catalog[0].id;
        }
        return {};
      } catch (error) {
        throw new Error(error);
      }
    },

    async saveBannerActivity(store, filters) {
      try {
        const insertMutation = {
          mutation: INSERT_BANNER_ACTIVITY_MUTATION,
          variables: {
            banner_id: filters.banner_id,
            action: filters.action,
          },
        };
        await apolloClient.mutate(insertMutation);
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mutations: {
    SET_BANNERS(state, banners) {
      Vue.set(state, 'banners', banners);
    },
  },
  getters: {
    bannersInfo: state => state.banners,
  },
};

export default banner;



// WEBPACK FOOTER //
// ./src/store/modules/buyer/banner.js